import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

class SingleModel extends Component {

    render() {
        return (
            <button className={`btn btn-flat single-model center-align ${this.props.isActive && this.props.bathtub.step6.GR !== '0' ? 'active' : ''}`} onClick={() => {
                if (this.props.bathtub.step6.GR !== '0') {
                    return this.props.handleClick(this)
                }
            }
            }>
                <div className='single-model__image'>
                    <img src={this.props.image} alt='single-model'/>
                </div>
                <div className='single-model__text'>
                    <p>{this.props.text}</p>
                </div>
            </button>
        )
    }

}

/**
 * Prop types
 * @type {{tempDetails: *}}
 */
SingleModel.propTypes = {
    handleClick: PropTypes.func.isRequired,
    image:       PropTypes.string.isRequired,
    text:        PropTypes.string.isRequired,
    isActive:    PropTypes.bool.isRequired,
    bathtub:     PropTypes.object.isRequired,
};

function mapStateToProps({bathtub}) {
    return {
        bathtub,
    }
}

export default connect(mapStateToProps)(SingleModel);



// WEBPACK FOOTER //
// ./src/components/bathtub-steps/StepSix/SingleModel.js